import { EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import style from './style.module.css';
import { FC, memo } from 'react';
import { Tooltip } from 'antd';

interface ITcEditIcon {
  onClick?: () => void;
  to?: string;
  tooltip?: string;
  blank?: boolean;
}

const TcEditIcon: FC<ITcEditIcon> = ({ onClick, to, tooltip, blank = false }) => {
  if (onClick)
    return (
      <span className={`inline ${style['green-icon']}`}>
        <Tooltip title={tooltip ? tooltip : 'ویرایش'}>
          <EditOutlined onClick={onClick} className='mx-[5px] text-t-primary-color inline-block' />
        </Tooltip>
      </span>
    );

  return (
    <span className={`inline ${style['green-icon']}`}>
      <Link to={to ? to : ''} target={blank ? '_blank' : '_self'}>
        <Tooltip title={tooltip ? tooltip : 'ویرایش'}>
          <EditOutlined className='mx-[5px] text-t-primary-color inline-block' />
        </Tooltip>
      </Link>
    </span>
  );
};

export default memo(TcEditIcon);
